import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApplicationParams } from 'models/Application';

const initialState: ApplicationParams = {
  includeDeletedData: undefined,
  includeInactiveData: undefined,
  returnDeletedDataOnly: undefined,
  orderByDirection: undefined,
  orderByField: undefined,
  applicationNameContains: undefined
};

export const freddyCadabbyParams = createSlice({
  name: 'freddyCadabbyParams',
  initialState,
  reducers: {
    setIncludeDeletedData: (state, { payload }: PayloadAction<ApplicationParams['includeDeletedData']>) => {
      state.includeDeletedData = payload;
    },
    setIncludeInactiveData: (state, { payload }: PayloadAction<ApplicationParams['includeInactiveData']>) => {
      state.includeInactiveData = payload;
    },
    setReturnDeletedDataOnly: (state, { payload }: PayloadAction<ApplicationParams['returnDeletedDataOnly']>) => {
      state.returnDeletedDataOnly = payload;
    },
    setOrderByDirection: (state, { payload }: PayloadAction<ApplicationParams['orderByDirection']>) => {
      state.orderByDirection = payload;
    },
    setOrderByField: (state, { payload }: PayloadAction<ApplicationParams['orderByField']>) => {
      state.orderByField = payload;
    },
    setApplicationNameContains: (state, { payload }: PayloadAction<ApplicationParams['applicationNameContains']>) => {
      state.applicationNameContains = payload;
    }
  }
});

export const { setIncludeDeletedData, setIncludeInactiveData, setOrderByDirection, setApplicationNameContains, setReturnDeletedDataOnly, setOrderByField } = freddyCadabbyParams.actions;
